import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { Phone, Mail } from 'lucide-react';
export function ContactPage() {
  return <div className="min-h-screen w-full bg-white selection:bg-slate-600 selection:text-white pt-20" data-id="element-179">
      <Header data-id="element-180" />

      <section className="relative min-h-[80vh] flex flex-col justify-center py-20 px-6 lg:px-8 bg-white overflow-hidden" data-id="element-181">
        {/* Geometric Background */}
        <div className="absolute top-0 right-0 w-1/2 h-full bg-gray-50 -skew-x-12 transform translate-x-1/4" data-id="element-182" />
        <div className="absolute bottom-0 left-0 w-64 h-64 border-4 border-slate-600 transform rotate-45 -translate-x-1/2 translate-y-1/2 opacity-20" data-id="element-183" />

        <div className="max-w-4xl mx-auto w-full relative z-10" data-id="element-184">
          <div className="mb-6 inline-block bg-slate-600 px-4 py-1 transform -skew-x-12" data-id="element-185">
            <span className="block transform skew-x-12 font-bold tracking-wider uppercase text-sm text-white" data-id="element-186">
              Contact Us
            </span>
          </div>

          <h1 className="text-5xl md:text-7xl font-black tracking-tighter text-black mb-8 leading-none" data-id="element-187">
            LET'S <br data-id="element-188" />
            <span className="text-slate-600" data-id="element-189">CONNECT</span>.
          </h1>

          <p className="text-xl text-gray-700 font-medium mb-12 max-w-md" data-id="element-190">
            Ready to sell or have questions? Reach out to our team directly.
            We're here to help.
          </p>

          <div className="space-y-8" data-id="element-191">
            <a href="tel:630-639-3533" className="flex items-center gap-6 group p-6 bg-white border border-gray-200 hover:border-slate-600 hover:shadow-lg transition-all duration-300" data-id="element-192">
              <div className="w-16 h-16 bg-slate-600 flex items-center justify-center text-white shrink-0" data-id="element-193">
                <Phone className="w-8 h-8" data-id="element-194" />
              </div>
              <div data-id="element-195">
                <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-196">
                  Call Us Anytime
                </p>
                <p className="text-2xl md:text-3xl font-black text-black group-hover:text-slate-600 transition-colors" data-id="element-197">
                  630-639-3533
                </p>
              </div>
            </a>

            <a href="mailto:ravenadvisorsllc@gmail.com" className="flex items-center gap-6 group p-6 bg-white border border-gray-200 hover:border-slate-600 hover:shadow-lg transition-all duration-300" data-id="element-198">
              <div className="w-16 h-16 bg-black flex items-center justify-center text-white shrink-0" data-id="element-199">
                <Mail className="w-8 h-8" data-id="element-200" />
              </div>
              <div data-id="element-201">
                <p className="text-sm font-bold text-gray-500 uppercase tracking-wider mb-1" data-id="element-202">
                  Email Us
                </p>
                <p className="text-xl md:text-2xl font-black text-black group-hover:text-slate-600 transition-colors break-all" data-id="element-203">
                  ravenadvisorsllc@gmail.com
                </p>
              </div>
            </a>
          </div>
        </div>
      </section>

      <Footer data-id="element-204" />
    </div>;
}